export default __webpack_public_path__ + "static/media/backArrowIcon.d6d8f2f4.svg";